import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Footer from '../../../Layout/Footer';
import Header from '../../../Layout/Header';
import feedback from '../../../../assets/img/notify.jpg';
import { Button, Form } from 'react-bootstrap';
import { useEffect } from 'react';
import { getMyTaskListSeller, getSellerInfo, taskReviewInfo } from '../../../../Redux/Task/action';
import { useState } from 'react';
import moment from 'moment';
import { Rating } from 'react-simple-star-rating';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { IMAGE_URL } from '../../../../api';
import { BiRupee } from 'react-icons/bi';
import loader from '../../../../assets/img/loader.gif';


const MytaskCompletedSeller = () => {

    const navigate = useNavigate();
    const { state } = useLocation();
    const [tasks, setTasks] = useState([])
    const [sellerinfo, setSellerinfo] = useState();
    const [isloader, setIsloader] = useState(false);
    useEffect(() => {
        let formData = new FormData();
        // formData.append(state?.data?.id);
        formData.append('status_object', 2);
        formData.append('limit', 12);
        // formData.append('sort_order', 1);
        // formData.append('category', 1);
        getMyTaskListSeller({ formData })((response) => {
            if (response && response.status) {
                setTasks(response?.data?.data)
            }
        });
        getSellerInfo(
            state?.data?.task_details?.id ? state?.data?.task_details?.id : state?.data?.task_details)((response) => {
                if (response && response.status) {
                    setSellerinfo(response?.data?.data)
                    formik.setValues({
                        ...formik.values,
                        comment: response.data.data.buyer_review.comment
                    })
                }
            });
    }, []);
    const validationSchema = Yup.object().shape({
        // rating: Yup.string()
        //     .required('Required'),
        // comment: Yup.string()
        //     .required('Required'),
    });
    const formik = useFormik({
        initialValues: {
            rating: "",
            comment: "",
        },
        validationSchema,
        onSubmit: (values) => {
            setIsloader(true)
            const task_details = state?.data?.task_details?.id ? state?.data?.task_details?.id : state?.data?.task_details
            // formData.append("cancel_reason", values.cancel_reason);
            taskReviewInfo(rating, values?.comment, task_details)((response) => {
                if (response && response.status) {
                    setIsloader(true)
                    getSellerInfo(state?.data?.task_details?.id ? state?.data?.task_details?.id : state?.data?.task_details)((response) => {
                        if (response && response.status) {
                            setIsloader(false)
                            setSellerinfo(response?.data?.data)
                            formik.setValues({
                                ...formik.values,
                                comment: response.data.data.buyer_review.comment
                            })
                        }
                    });
                    // navigate("/mytaskcompletedseller")
                }
                else {
                    setIsloader(false)
                    formik.setErrors({
                        comment: response?.response?.data?.data?.errors?.comment
                    })
                }

            });
        },
    });


    const [rating, setRating] = useState(0)

    // Catch Rating value
    const handleRating = (rate: number) => {
        setRating(rate)
        // other logic
    }


    return (
        <React.Fragment>
            <Header />
            <section>
                <div className="breadcrumbs">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 my-auto">
                                <h1>My Task </h1>
                                <ul className="trail-items">
                                    <li className="trail-item trail-begin">
                                        <Link to="/">
                                            <span itemProp="name">Home</span><i className="bi bi-chevron-double-right"></i>
                                        </Link>
                                    </li>
                                    <li className="trail-item trail-end">
                                        <span itemProp="item"><span itemProp="name"> Task Details</span></span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="mytask-details">
                <div className="container">
                    <div className="row task-details-main">
                        <div className='col-lg-6'>
                            <div className='border-right-task'>
                                <div className='task-details-flex'>
                                    <h5>{state?.data?.task_status?.title ? state?.data?.task_status?.title : state?.data?.task_details?.title}</h5>
                                    {state?.data?.seller_details && state?.data?.seller_details[0]?.bid_rate || state?.data?.assigned_data && state?.data?.assigned_data[0]?.bid_rate ?
                                        <p>Bid Rate: <i class="bi bi-currency-rupee"></i>{parseFloat(state?.data?.assigned_data && state?.data?.assigned_data[0]?.bid_rate ? state?.data?.assigned_data[0]?.bid_rate : state?.data?.seller_details && state?.data?.seller_details[0]?.bid_rate).toFixed(1)}</p>
                                        :
                                        <div className="member-info">
                                            <p>Chat rate: <BiRupee size="20" style={{ color: "#000" }} />{parseFloat(state?.data?.assigned_data && state?.data?.assigned_data[0]?.chat_rate ? state?.data?.assigned_data[0]?.chat_rate : state?.data?.seller_details && state?.data?.seller_details[0]?.chat_rate).toFixed(1)}</p>
                                            <p>Call rate: <BiRupee size="20" style={{ color: "#000" }} />{parseFloat(state?.data?.assigned_data && state?.data?.assigned_data[0]?.call_rate ? state?.data?.assigned_data[0]?.call_rate : state?.data?.seller_details && state?.data?.seller_details[0]?.call_rate).toFixed(1)} / {state?.data?.assigned_data && state?.data?.assigned_data[0]?.time_field == 1 ? "hour" : state?.data?.assigned_data && state?.data?.assigned_data[0]?.time_field == 2 ? "min" : state?.data?.seller_details && state?.data?.seller_details[0]?.time_field == 1 ? "hour" : state?.data?.seller_details && state?.data?.seller_details[0]?.time_field == 2 && "min"}</p>
                                        </div>
                                    }
                                    {/* {state?.data?.seller_details[0]?.chat_rate != "" &&
                                        <div className="member-info">
                                            <p>Chat rate: {parseFloat(state?.data?.seller_details[0]?.chat_rate).toFixed(1)}</p>
                                            <p>Call rate: {parseFloat(state?.data?.seller_details[0]?.call_rate).toFixed(1)}</p>
                                        </div>
                                    } */}
                                    {/* <div className="member-info">
                                        <p>Chat rate: {parseFloat(state?.data?.seller_details[0]?.chat_rate).toFixed(1)}</p>
                                        <p>Call rate: {parseFloat(state?.data?.seller_details[0]?.call_rate).toFixed(1)}</p>
                                    </div> */}
                                </div>
                                <h6>Posted on: {moment(state?.data?.task_details?.date_choice).format('ll')}</h6>
                                <h6>Posted by: <span style={{ color: "#1bbaed", fontWeight: "700" }}>{state?.data?.task_status?.posted_by ? state?.data?.task_status?.posted_by : state?.data?.task_details?.posted_by?.username}</span></h6>
                                <div className='service-desc'>
                                    <h5>Service Description</h5>
                                    <p>{state?.data?.task_status?.description ? state?.data?.task_status?.description : state?.data?.task_details?.description}</p>
                                </div>
                            </div>

                        </div>
                        <div className='col-lg-6'>
                            <div className='offers'>
                                <div className='task-details-flex'>
                                    <h5>Buyer Info:</h5>
                                </div>

                                <div className='offers-link'>
                                    <div className="member d-flex align-items-center">
                                        <div className="pic"><img src={IMAGE_URL + sellerinfo?.image?.image} className="img-fluid" alt="" style={{ width: "80px" }} /></div>
                                        <div className="member-info">
                                            <h4>{sellerinfo?.image?.user_data?.username}</h4>
                                            {sellerinfo?.buyer_review?.rating &&
                                                <span className="badge badge-light-warning">{sellerinfo?.buyer_review?.rating}<i class="bi bi-star-fill"></i></span>
                                            }
                                            <p>{sellerinfo?.buyer_review?.comment}</p>
                                        </div>

                                    </div>
                                    <div className="">
                                        {sellerinfo?.review_flag == false &&
                                            <div className="member-info">
                                                <h5>Rate the Buyer</h5>
                                                <Form onSubmit={formik.handleSubmit}>
                                                    <Rating
                                                        onClick={handleRating}
                                                        // onPointerEnter={onPointerEnter}
                                                        // onPointerLeave={onPointerLeave}
                                                        // onPointerMove={onPointerMove}
                                                        transition
                                                    /* Available Props */
                                                    />
                                                    <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                                                        <Form.Label className='comments'>Enter comments:</Form.Label>
                                                        <Form.Control
                                                            as="textarea"
                                                            name='comment'
                                                            onChange={formik.handleChange}
                                                            isValid={formik.touched.comment && !formik.errors.comment}
                                                            isInvalid={!!formik.errors.comment}
                                                            rows={3}
                                                            value={formik.values?.comment}
                                                        />
                                                        <Form.Control.Feedback type="invalid">{formik.errors.comment}</Form.Control.Feedback>
                                                    </Form.Group>
                                                    <div className='text-center'>
                                                        {isloader == true ?
                                                            <div className='loader'>
                                                                <img src={loader} alt="" />
                                                            </div>
                                                            :
                                                            <Button className='offers-assignbtn' type="submit" variant="primary">Submit</Button>
                                                        }
                                                    </div>
                                                </Form>
                                            </div>
                                        }
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </React.Fragment >
    )
}

export default MytaskCompletedSeller;